(() => {
  'use strict';
  const configElement = document.getElementById('ThemeConfig');
  if (!configElement) return;
  const cfg = JSON.parse(configElement.textContent);
  const drawer = document.getElementById('CartDrawer');
  const lightbox = document.getElementById('ImageDialog');
  let queue = Promise.resolve(), opener = null;
  const root = cfg.root.endsWith('/') ? cfg.root : cfg.root + '/';
  async function api(path, body) {
    const response = await fetch(root + path, body === undefined ? {headers:{Accept:'application/json'}} : {
      method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify(body)
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'No pudimos actualizar el carrito. Inténtalo nuevamente.');
    return result;
  }
  function error(message, scope) {
    (scope ? [scope] : document.querySelectorAll('[data-cart-contents]')).forEach(el => {
      const target = el.querySelector('.form-error, .cart-error');
      if (target) target.textContent = message;
    });
  }
  async function syncGift(cart) {
    if (!cfg.giftAuto || !cfg.giftFree || !cfg.giftId) return cart;
    const giftId = Number(cfg.giftId);
    const gifts = cart.items.filter(item => Number(item.variant_id) === giftId);
    const hasJewelry = cart.items.some(item => Number(item.variant_id) !== giftId);
    if (!hasJewelry && gifts.length) {
      for (const gift of gifts) cart = await api('cart/change.js',{id:gift.key,quantity:0});
    } else if (hasJewelry && !gifts.length) {
      await api('cart/add.js',{items:[{id:giftId,quantity:1,properties:{_medidor_gratis:'true'}}]});
      cart = await api('cart.js');
    } else if (hasJewelry && gifts.length) {
      for (const extra of gifts.slice(1)) cart = await api('cart/change.js',{id:extra.key,quantity:0});
      const keep = cart.items.find(item => Number(item.variant_id) === giftId);
      if (keep && keep.quantity !== 1) cart = await api('cart/change.js',{id:keep.key,quantity:1});
    }
    return cart;
  }
  function count(cart) {
    const n = cart.items.reduce((total,item) => total + (cfg.giftFree && Number(item.variant_id) === Number(cfg.giftId) ? 0 : item.quantity),0);
    document.querySelectorAll('[data-cart-count]').forEach(el => {el.textContent=String(n);});
  }
  async function refresh(cart) {
    count(cart);
    const response = await fetch(root+'?section_id=cart-panel',{headers:{Accept:'text/html'}});
    if (!response.ok) throw new Error('El carrito se actualizó, pero no pudimos mostrarlo. Recarga la página para verlo.');
    const html = await response.text();
    const parsed = new DOMParser().parseFromString(html,'text/html');
    const content = parsed.querySelector('[data-cart-contents]');
    if (!content) throw new Error('Recarga la página para ver el carrito actualizado.');
    document.querySelectorAll('[data-cart-contents]').forEach(el => {el.replaceWith(content.cloneNode(true));});
  }
  function closeCart() {
    drawer.close();
    document.body.classList.remove('body-locked');
    if(opener?.isConnected) opener.focus();
  }
  function openCart() {
    if(!drawer.open) {opener=document.activeElement;drawer.showModal();document.body.classList.add('body-locked');}
  }
  function task(fn) {
    const result = queue.then(fn);
    queue=result.catch(()=>{});
    return result;
  }
  function busy(state) {
    document.querySelectorAll('[data-cart-contents] button,[data-checkout-form] button').forEach(el => {el.disabled=state;});
  }
  document.addEventListener('click',event => {
    const open=event.target.closest('[data-cart-open]');
    if(open){event.preventDefault();openCart();task(async()=>{busy(true);try{await refresh(await syncGift(await api('cart.js')));}catch(e){error(e.message);}finally{busy(false);}});return;}
    if(event.target.closest('[data-cart-close]')){closeCart();return;}
    const menu=event.target.closest('[data-menu-toggle]');
    if(menu){const header=menu.closest('header');header.classList.toggle('menu-open');menu.setAttribute('aria-expanded',String(header.classList.contains('menu-open')));return;}
    const imageButton=event.target.closest('[data-lightbox]');
    if(imageButton){const img=imageButton.querySelector('img'),large=document.getElementById('LargeImage');large.src=img.currentSrc||img.src;large.alt=img.alt;lightbox.showModal();return;}
    if(event.target.closest('[data-lightbox-close]')){lightbox.close();return;}
    const quantity=event.target.closest('[data-quantity-delta]');
    if(quantity){const input=quantity.closest('.quantity-picker').querySelector('input');input.value=Math.max(1,(parseInt(input.value,10)||1)+Number(quantity.dataset.quantityDelta));return;}
    const change=event.target.closest('[data-cart-key]');
    if(change){event.preventDefault();const key=change.dataset.cartKey,quantity=Number(change.dataset.cartQuantity);task(async()=>{busy(true);error('');try{const cart=await api('cart/change.js',{id:key,quantity});await refresh(await syncGift(cart));}catch(e){error(e.message);}finally{busy(false);}});}
  });
  drawer.addEventListener('cancel',event=>{event.preventDefault();closeCart();});
  drawer.addEventListener('click',event=>{if(event.target===drawer){const r=drawer.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)closeCart();}});
  lightbox.addEventListener('click',event=>{if(event.target===lightbox)lightbox.close();});
  document.addEventListener('change',event=>{
    if(event.target.matches('[data-sort]'))event.target.form.submit();
    if(event.target.matches('[data-variant-select]')){
      const section=event.target.closest('[data-product-section]'),option=event.target.selectedOptions[0],button=section.querySelector('[data-add-button]');
      section.querySelector('[data-product-price]').textContent=option.dataset.price;
      button.disabled=option.dataset.available!=='true';
      if(!button.dataset.label)button.dataset.label=button.textContent.trim();
      button.textContent=button.disabled?'Agotado':button.dataset.label;
      const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
    }
  });
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(form.matches('[data-product-form]')){
      event.preventDefault();const button=form.querySelector('[data-add-button]');button.disabled=true;error('',form);
      task(async()=>{
        try{
          const body=new FormData(form),quantity=Number(body.get('quantity'));
          if(!Number.isInteger(quantity)||quantity<1)throw new Error('Selecciona una cantidad válida.');
          const properties={};for(const [k,v] of body){const m=k.match(/^properties\[(.+)\]$/);if(m&&String(v).trim())properties[m[1]]=v;}
          await api('cart/add.js',{items:[{id:Number(body.get('id')),quantity,properties}]});
          openCart();
          try{await refresh(await syncGift(await api('cart.js')));}catch(e){error(e.message);}
        }catch(e){error(e.message,form);}finally{const option=form.querySelector('[data-variant-select]').selectedOptions[0];button.disabled=option.dataset.available!=='true';}
      });
    }
    if(form.matches('[data-checkout-form]')){
      event.preventDefault();task(async()=>{busy(true);error('');try{await syncGift(await api('cart.js'));const checkout=document.createElement('form');checkout.method='post';checkout.action=form.action;const marker=document.createElement('input');marker.type='hidden';marker.name='checkout';marker.value='';checkout.appendChild(marker);document.body.appendChild(checkout);HTMLFormElement.prototype.submit.call(checkout);}catch(e){error(e.message);busy(false);}});
    }
  });
  task(async()=>{try{await refresh(await syncGift(await api('cart.js')));}catch(e){error(e.message);}});
})();
